export const PIX = 1

export const BOLETO = 2

export const CREDIT_CARD = 3

export const PIX_INSTALLMENT = 4
